import React from 'react';
import { Phone, Mail, MapPin, ExternalLink } from 'lucide-react';
import { companyInfo } from '../data/mock';

const ContactSection = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-slate-50">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Kontaktujte nás
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Rádi zodpovíme vaše dotazy a upřesníme nabídku
            </p>
          </div>
          
          <div className="bg-gradient-to-br from-cyan-600 to-blue-600 rounded-3xl shadow-2xl overflow-hidden">
            <div className="p-8 md:p-12 text-white">
              <div className="grid md:grid-cols-2 gap-12">
                {/* Company Info */}
                <div>
                  <img
                    src={companyInfo.logo}
                    alt={companyInfo.name}
                    className="h-12 mb-6"
                  />
                  <h3 className="text-2xl font-bold mb-6">
                    {companyInfo.fullName}
                  </h3>
                  <p className="text-cyan-100 mb-8 leading-relaxed">
                    Specializujeme se na profesionální cateringové služby pro firemní akce, 
                    svatby a velké eventy. S více než 15 lety zkušeností jsme připravili 
                    stovky úspěšných akcí pro spokojené zákazníky.
                  </p>
                  <a
                    href={companyInfo.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center space-x-2 bg-white/20 hover:bg-white/30 backdrop-blur-sm px-6 py-3 rounded-xl transition-all duration-300 font-medium"
                  >
                    <span>Navštivte náš web</span>
                    <ExternalLink className="w-4 h-4" />
                  </a>
                </div>
                
                {/* Contact Person */}
                <div>
                  <h3 className="text-2xl font-bold mb-6">Kontaktní osoba</h3>
                  <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 mb-6">
                    <div className="flex items-center space-x-4 mb-4">
                      <div className="bg-white rounded-full w-16 h-16 flex items-center justify-center text-cyan-600 text-2xl font-bold">
                        {companyInfo.contact.name.split(' ').map(n => n[0]).join('')}
                      </div>
                      <div>
                        <div className="text-xl font-bold">
                          {companyInfo.contact.name}
                        </div>
                        <div className="text-cyan-100">
                          {companyInfo.contact.position}
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="space-y-4">
                    <a
                      href={`tel:${companyInfo.contact.phone}`}
                      className="flex items-center space-x-4 bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-xl p-4 transition-all duration-300 border border-white/20"
                    >
                      <div className="bg-white/20 rounded-lg p-3">
                        <Phone className="w-6 h-6" />
                      </div>
                      <div>
                        <div className="text-sm text-cyan-100">Telefon</div>
                        <div className="font-bold text-lg">{companyInfo.contact.phone}</div>
                      </div>
                    </a>
                    
                    <a
                      href={`mailto:${companyInfo.contact.email}`}
                      className="flex items-center space-x-4 bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-xl p-4 transition-all duration-300 border border-white/20"
                    >
                      <div className="bg-white/20 rounded-lg p-3">
                        <Mail className="w-6 h-6" />
                      </div>
                      <div>
                        <div className="text-sm text-cyan-100">Email</div>
                        <div className="font-bold text-lg">{companyInfo.contact.email}</div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Client References */}
          <div className="mt-16 text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-8">
              Důvěřují nám
            </h3>
            <div className="flex flex-wrap items-center justify-center gap-12">
              <div className="text-gray-400 font-semibold text-lg">Fatra a.s.</div>
              <div className="text-gray-400 font-semibold text-lg">Česká televize</div>
              <div className="text-gray-400 font-semibold text-lg">Amazon</div>
              <div className="text-gray-400 font-semibold text-lg">Barum Continental</div>
              <div className="text-gray-400 font-semibold text-lg">Plzeňský Prazdroj</div>
              <div className="text-gray-400 font-semibold text-lg">KBP</div>
              <div className="text-gray-400 font-semibold text-lg">Greiner Packaging</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
